<!--
Author: TangChen
Date: 2018-11-06
Desc: CRS信息，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户信息</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-taxes-list bizcomp">
            <!-- <comp-title :title="title">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/info' }">个人中心</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
                </el-breadcrumb>
            </comp-title> -->
            <el-table
                :data="taxesLists"
                style="width: 100%"
                class="tab-list-tit"
                :header-cell-style="{ background: 'var(--color-divided' }"
            >
                <el-table-column prop="custname" label="税收人全称" align="center" />
                <el-table-column
                    prop="certificatetype"
                    label="证件类型"
                    align="center"
                    :formatter="certyFormat"
                />
                <el-table-column prop="certificateno" label="证件号码" align="center" />
                <el-table-column
                    prop="taxesplace"
                    label="税收居民国家/地区"
                    align="center"
                    :formatter="countyFormat"
                />
                <el-table-column
                    prop="taxestype"
                    label="税收类型"
                    align="center"
                    :formatter="taxtyFormat"
                />
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <div class="btn-group">
                            <template v-if="$util.getConfig().hideFunc">
                                <el-tooltip
                                    v-if="birth === ''"
                                    class="item"
                                    effect="info"
                                    :content="'你未设置出生日期信息，请前往个人信息设置'"
                                    placement="left"
                                >
                                    <el-button type="text" size="small">修改</el-button>
                                </el-tooltip>
                                <el-button
                                    v-if="birth !== ''"
                                    type="text"
                                    v-on:click.once="
                                        $router.push({
                                            name: 'taxesinfo',
                                            query: {
                                                taxid: scope.row.taxiesinfoid,
                                                tax:
                                                    taxesLists.length > 1
                                                        ? taxesLists[0].taxestype
                                                        : ''
                                            }
                                        })
                                    "
                                >
                                    修改
                                </el-button>
                            </template>
                            <template v-else>
                                <el-button
                                    type="text"
                                    size="small"
                                    v-on:click.once="
                                        $router.push({
                                            name: 'taxesinfo',
                                            query: {
                                                taxid: scope.row.taxiesinfoid,
                                                tax:
                                                    taxesLists.length > 1
                                                        ? taxesLists[0].taxestype
                                                        : ''
                                            }
                                        })
                                    "
                                >
                                    查看
                                </el-button>
                            </template>
                            <el-button
                                v-if="scope.row.taxestype !== '0' && taxesLists.length !== 1"
                                type="text"
                                size="small"
                                v-on:click="beforeDelTaxes(scope.row.taxiesinfoid)"
                            >
                                删除
                            </el-button>
                            <!-- <el-button
                            type="red"
                            size="small"
                            v-on:click="beforeDelTaxes(scope.row.taxiesinfoid)"
                        >
                            删除
                        </el-button>-->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <div v-if="showBtns" class="addTax">
                    <el-tooltip
                        v-if="birth === ''"
                        class="item"
                        effect="info"
                        :content="'你未设置出生日期信息，请前往个人信息设置'"
                        placement="left"
                    >
                        <el-button type="lock">
                            <i class="fa fa-plus-circle" aria-hidden="true" />
                            <span>新增CRS信息</span>
                        </el-button>
                    </el-tooltip>
                    <el-button
                        v-else
                        type="primary"
                        v-on:click.once="
                            $router.push({
                                name: 'taxesinfo',
                                query: {
                                    lock: taxesLists.length !== 0,
                                    tax: taxesLists.length > 0 ? taxesLists[0].taxestype : '',
                                    type: 'add'
                                }
                            })
                        "
                    >
                        <i class="fa fa-plus-circle" aria-hidden="true" />
                        <span>新增CRS信息</span>
                    </el-button>
                </div>
            </el-row>
            <el-dialog
                title="提示"
                :visible.sync="tpasswdDialogVisible"
                class="prop info-tips"
                width="480px"
            >
                <div class="investor-tips">
                    <div class="prompt-info">
                        <p>
                            <i class="el-icon-warning" aria-hidden="true" />
                            <span>删除操作需要密码校验</span>
                        </p>
                    </div>
                    <el-form
                        ref="ruleForm"
                        class="two-cols-form"
                        :model="ruleForm"
                        :rules="rules"
                        label-width="37px"
                        size="small"
                    >
                        <el-form-item label="" prop="tpasswd">
                            <el-input
                                v-model="ruleForm.tpasswd"
                                type="password"
                                :maxlength="20"
                                placeholder="请输入交易密码"
                            />
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button v-on:click="tpasswdDialogVisible = false">返回</el-button>
                    <el-button type="primary" v-on:click="cancelConfirm">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";

export default {
    name: "TaxesList",
    mixins: [mixin],
    data() {
        return {
            taxestypes: [],
            taxesLists: [],
            taxiesinfoid: "",
            birth: "",
            ruleForm: {
                tpasswd: ""
            },
            rules: {
                tpasswd: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            },
            tpasswdDialogVisible: false,
            showBtns: false
        };
    },
    created() {
        const info = this.$cache.getUser();
        this.birth = info.birthday;
        this.getTaxesInfo();
    },
    methods: {
        certyFormat(row, column, value) {
            return this.$cache.getDict("130007", value);
        },
        countyFormat(row, column, value) {
            return this.$cache.getDict("120109", value) || "--";
        },
        taxtyFormat(row, column, value) {
            return this.$cache.getDict("120043", value);
        },
        // 删除税收居民信息
        beforeDelTaxes(id) {
            const _this = this;
            this.taxiesinfoid = id;
            this.$confirm("您确认删除该税收居民身份信息吗？", "税收居民信息删除", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                if (_this.$cache.getPwdCheck("T5")) {
                    _this.ruleForm.tpasswd = "";
                    _this.tpasswdDialogVisible = true;
                } else {
                    _this.delTaxes();
                }
            });
        },
        cancelConfirm() {
            var _this = this;
            _this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    _this.tpasswdDialogVisible = false;
                    _this.delTaxes();
                } else {
                    return false;
                }
            });
        },
        async delTaxes() {
            var _this = this;
            let id = this.taxiesinfoid;
            const res = await userApi.delAcctCrsInfoHandler({ taxiesinfoid: id });
            if (res.data) {
                _this.taxesLists = _this.taxesLists.filter((item) => {
                    return item.taxiesinfoid !== id;
                });
                _this.$message({
                    type: "success",
                    message: "删除成功!"
                });
            }
            this.getTaxesInfo();
        },
        async getTaxesInfo() {
            this.taxesLists = [];
            const res = await userApi.qryAcctCrsInfoService({});
            if (res.data) {
                if (!res.data.length > 0) {
                    this.showBtns = true;
                }
                const _info = this.$cache.getUser();
                for (let i = 0; i < res.data.length; i++) {
                    let _obj = {
                        custname: _info.custname,
                        certificatetype: _info.certificatetype,
                        certificateno: _info.certificateno
                    };
                    _obj.taxesplace = res.data[i].taxesplace || "";
                    _obj.taxestype = res.data[i].taxestype || "";
                    _obj.taxiesinfoid = res.data[i].taxiesinfoid;
                    if (_obj.taxestype.trim()) this.taxesLists.push(_obj);
                }
            }
        }
    }
};
</script>
<style lang="scss">
[v-cloak] {
    display: none;
}
/*用户信息 */
.bizcomp-taxes-list {
    padding-bottom: 50px;
    .el-table {
        border: 1px solid var(--color-border-base);
    }
    .el-table td.el-table__cell div {
        color: var(--color-text-primary);
    }
    .el-button.is-plain:hover,
    .el-button.is-plain:focus,
    .el-button.is-disabled.is-plain {
        background-color: transparent;
        border-color: transparent;
    }
    .el-button--text {
        font-size: 14px;
        font-weight: normal;
        color: var(--color-primary);
    }
    .el-button--text.is-disabled {
        color: var(--color-text-weak);
    }
    .addTax {
        text-align: center;
        padding: 35px 0;
        .el-button {
            font-size: $f16;
            padding: 7px 20px;
            span {
                vertical-align: middle;
            }
        }
        i {
            font-size: $f24;
            margin-right: 5px;
            vertical-align: middle;
        }
    }
}
</style>
